import { CanActivateAppGuard } from './app.guard';
import { AuthGuard } from './auth.guard';
import { OnboardingGuard } from './onboarding.guard';

export const APP_GUARDS = [
  CanActivateAppGuard,
  AuthGuard,
  OnboardingGuard
];
